module.exports = { "default": require("core-js/library/fn/string/from-code-point"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/string/from-code-point.js
// module id = 244
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/string/from-code-point.js